import React, { useState, useEffect } from 'react';
import { Card, Row, Col, Form } from 'react-bootstrap';
import "react-datepicker/dist/react-datepicker.css";
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Line } from 'react-chartjs-2';
import dateFormat from 'dateformat';
import moment from 'moment';

import Chart from 'chart.js/auto';

let delayed;

const options = {
    responsive: true,
    scales: {
        y: {},
        x: {},
    },
    animations: {
        radius: {
            duration: 500,
            easing: 'linear',
            loop: (context) => context.active
        }
    },
    animation: {
        onComplete: () => {
            delayed = true;
        },
        delay: (context) => {
            let delay = 0;
            if (context.type === 'data' && context.mode === 'default' && !delayed) {
                delay = context.dataIndex * 5 + context.datasetIndex * 2;
            }
            return delay;
        },
    },
    hoverRadius: 6,
    hoverBackgroundColor: 'yellow',
    interaction: {
        mode: 'nearest',
        intersect: false,
        axis: 'x'
    },
    plugins: {
        tooltip: {
            enabled: true
        },
        title: {
            display: true,
            text: '',
        }
    }


}

const plugins = [{
    afterDraw: function (chart) {
        if (chart.data.datasets.length > 0) {
            if (chart.data.datasets[0].data.length === 0) {
                var width = chart.width,
                    height = chart.height,
                    ctx = chart.ctx;
                ctx.restore();
                var fontSize = (height / 160).toFixed(2);
                ctx.font = fontSize + "em sans-serif";
                ctx.textBaseline = "top";
                var text = "Nenhuma Informação Disponível",
                    textX = Math.round((width - ctx.measureText(text).width) / 2),
                    textY = height / 2;
                ctx.fillText(text, textX, textY);
                ctx.save();
            }
        }
    }
}]

function Grafico(props) {
    const { socket, serial, setLoading, medidas } = props;

    const [curvas, setCurvas] = useState([]);
    const [curvaSelecionada, setCurvaSelecionada] = useState('');
    const [allData, setAllData] = useState([]);

    const dataAtual = new Date();
    const [startDate, setStartDate] = useState(dataAtual);
    const [endDate, setEndDate] = useState(dataAtual);
    const [flagDate, setFlagDade] = useState(false);


    var lastResponseData = [];

    const [dataUmidade, setDataUmidade] = useState({
        labels: [],
        datasets: []
    });

    const [dataTemperatura, setDataTemperatura] = useState({
        labels: [],
        datasets: []
    });

    const [dataPH, setDataPH] = useState({
        labels: [],
        datasets: []
    });

    const handleChangeStartDate = (event) => {
        const [year, month, day] = event.target.value.split("-");
        const rawDate = new Date(year, month - 1, day); // Cria com mês baseado em zero
        rawDate.setHours(0, 0, 0); // Ajusta para 03:00:00 no fuso local
        setStartDate(rawDate); // Define o estado corretamente
    };

    const handleChangeEndDate = (event) => {
        const [year, month, day] = event.target.value.split("-");
        const rawDate = new Date(year, month - 1, day); // Cria com mês baseado em zero
        rawDate.setHours(0, 0, 0); // Ajusta para 03:00:00 no fuso local
        setEndDate(rawDate);
    };

    useEffect(() => {
        setFlagDade(true)
        if (startDate > endDate) {
            alert("Data de inicio deve ser maior que data final!")
        } else if (startDate < endDate) {
            handleGetDate(startDate, endDate)
        }
    }, [startDate, endDate])

    const handleGetDate = (startDate, endDate) => {
        if (!serial) {
            return
        }
        setLoading(true)
        socket.send(
            JSON.stringify({
                type: 'message',
                room: serial,
                content: {
                    command: 'web_browser',
                    parameters: {
                        value: 'get_graphic',
                        page: 'graphic',
                        start_date: startDate,
                        end_date: endDate
                    }
                },
            })
        );
    };

    const handleGetGraphic = () => {
        if (!serial) {
            return
        }
        setLoading(true)
        socket.send(
            JSON.stringify({
                type: 'message',
                room: serial,
                content: {
                    command: 'web_browser',
                    parameters: {
                        value: 'get_graphic',
                        page: 'graphic'
                    }
                },
            })
        );
    };

    const processData = (responseData) => {
        getData(responseData)
    }

    const handleChange = (event) => {
        setCurvaSelecionada(event.target.value);
        processData(allData.filter(i => i.curva === event.target.value));
    }

    const handleInitial = async (data) => {
        const newData = data.map(item => {
            item.date = moment(item.data, "DD/MM/YYYY - HH:mm:ss").toISOString()
            item.temperature = item.temperatura.replace("°C", "")

            return item;
        });

        if (newData.length && !arraysEqual(newData, lastResponseData)) {
            lastResponseData = newData;
            const curvas = [...new Set(newData.map(({ curva }) => curva))];
            setCurvas(curvas);
            const curvaSelecionada = newData[newData.length - 1]?.curva || '';
            setCurvaSelecionada(curvaSelecionada);
            setAllData(newData);
            processData(newData.filter(({ curva }) => curva === curvaSelecionada));
        }
    };

    const arraysEqual = (a, b) => {
        return JSON.stringify(a) === JSON.stringify(b);
    };

    const getData = async (data) => {
        try {
            const labels = data.map(i => dateFormat(i.date, "dd/mm/yy' 'HH:MM"))
            setDataUmidade({
                labels,
                datasets: [
                    {
                        label: 'Umidade',
                        data: data.map((i) => parseFloat(i.umidade).toFixed(1)),
                        borderColor: '#1C4220',
                        borderWidth: 2,
                        fill: true,
                        pointRadius: 2,
                        tension: 0.2,
                        datalabels: {
                            display: 'auto',
                            align: 'end',
                            font: {
                                weight: 'bold',
                                size: 13,
                            }
                        },
                    }
                ],
            });

            setDataTemperatura({
                labels,
                datasets: [
                    {
                        label: 'Temperatura',
                        data: data.map(i => parseFloat(i.temperature).toFixed(1)),
                        borderColor: '#1C4220',
                        borderWidth: 2,
                        fill: true,
                        pointRadius: 2,
                        tension: 0.2,
                        datalabels: {
                            display: 'auto',
                            align: 'end',
                            font: {
                                weight: 'bold',
                                size: 13,
                            }
                        },
                    }
                ],
            });

            setDataPH({
                labels,
                datasets: [
                    {
                        label: 'PH',
                        data: data.map(i => (parseFloat(i.ph_ref).toFixed(0).replace(/\D/g, ""))),
                        borderColor: '#1C4220',
                        borderWidth: 2,
                        fill: true,
                        pointRadius: 2,
                        tension: 0.2,
                        datalabels: {
                            display: 'auto',
                            align: 'end',
                            font: {
                                weight: 'bold',
                                size: 13,
                            }
                        },
                    }
                ],
            })

        } catch (err) {
            console.log(err.message)
        }
    }

    const getFormattedDate = (dateString) => {
        const date = new Date(dateString);
        return isNaN(date.getTime()) ? "" : date.toISOString().split("T")[0];
    };

    useEffect(() => {
        handleGetGraphic();
        const intervalId = setInterval(() => {
            if (!flagDate) {
                handleGetGraphic();
            } else {
                return
            }
        }, 120000)
        return () => clearInterval(intervalId);
    }, [serial]);

    useEffect(() => {
        handleInitial(medidas)
    }, [medidas]);

    return (
        <Card className="p-3" style={{ background: "white" }}>
            <Row className='g-2'>

                <Col className="mb-3" xs={12}>
                    <div className="d-flex align-items-center justify-content-start">
                        <Form.Select
                            className="border-success mt-1 mb-1 text-success me-2"
                            aria-label="Default select example"
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={curvaSelecionada}
                            onChange={handleChange}
                            style={{ width: 175 }}
                        >
                            {curvas ? curvas.map((item) => (
                                <option key={item} value={item}>{item}</option>
                            )) : null}
                        </Form.Select>

                        <Form.Control
                            className="border-success ms-1 mt-1 mb-1 text-success me-2"
                            style={{ width: 175 }}
                            type="date"
                            value={getFormattedDate(startDate)}
                            onChange={handleChangeStartDate}
                        />

                        <Form.Control
                            className="border-success ms-1 mt-1 mb-1 text-success"
                            style={{ width: 175 }}
                            type="date"
                            value={getFormattedDate(endDate)}
                            onChange={handleChangeEndDate}
                        />
                    </div>
                </Col>

                <hr />
                <Col className='mb-3' xs={12} sm={12} md={12} lg={12} xl={12}>
                    <Line
                        height={50}
                        options={options}
                        data={dataUmidade}
                        plugins={[plugins, ChartDataLabels]}
                    />
                </Col>
                <hr />
                <Col className='mt-3 mb-3' xs={12} sm={12} md={12} lg={12} xl={12}>
                    <Line
                        height={50}
                        options={options}
                        data={dataTemperatura}
                        plugins={[plugins, ChartDataLabels]}
                    />
                </Col>
                <hr />
                <Col className='mt-3 mb-3' xs={12} sm={12} md={12} lg={12} xl={12}>
                    <Line
                        height={50}
                        options={options}
                        data={dataPH}
                        plugins={[plugins, ChartDataLabels]}
                    />
                </Col>
            </Row>
        </Card>
    );
}

export default Grafico;
